import { Link } from 'react-router-dom';
import * as styles from './NotFoundPage.css';

export const NotFoundPage = () => {
    return (
        <div data-testid="not-found-page" className={styles.container}>
            <h1 className={styles.title}>404 - Page Not Found</h1>
            <p>The page you are looking for does not exist.</p>
            <Link to={`/app`}>Go back to Main</Link>
        </div>
    );
};
